export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8292.0889d2ce.jpg";